export default "/_next/static/images/brand-magic-star-logo-pond-a17b7c34fdbb6d8199dff58ed4e0964a.svg";